import { render, staticRenderFns } from "./qdetail.vue?vue&type=template&id=1c39e588&scoped=true&"
import script from "./qdetail.vue?vue&type=script&lang=js&"
export * from "./qdetail.vue?vue&type=script&lang=js&"
import style0 from "./qdetail.vue?vue&type=style&index=0&id=1c39e588&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c39e588",
  null
  
)

export default component.exports